import React, { useEffect, useState } from "react";
import roleService from "../Services/roleService";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import warehouseService from "../Services/warehouseService";
import SecondaryButton from "../Components/SecondaryButton";
import { MdOutlineAdd } from "react-icons/md";

const AddWarehouse = ({ edit = false }) => {
  const [loading, setLoading] = useState(false);
  const [ID, setID] = useState();

  const navigate = useNavigate();

  const [data, setData] = useState({
    name: "",
    location: "",
    area: "",
  });
  const [errors, setErrors] = useState({
    name: false,
    location: false,
    area: false,
  });
  const [regex, setRegex] = useState({
    name: /.{1,50}$/,
    location: /.{1,50}$/,
    area: /.{1,50}$/,
  });

  // useEffect(() => {
  //     if (edit) {
  //         if (params.get("id")) {
  //             roleService.getSingle(params.get("id")).then((res) => {
  //                 setData(d => ({ ...d, name: res.role.name }))
  //                 setID(res.role.id)
  //             })
  //         }
  //     }
  // },[])

  const handleChange = (e) => {
    setData((d) => ({ ...d, [e.target.name]: e.target.value }));
    setErrors((errs) => ({ ...errs, [e.target.name]: false }));
  };

  const submit = () => {
    setLoading(true);
    let hasError = false;
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        console.log(v);
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill all the required fields");
      setLoading(false);
    } else {
      if (!edit) {
        warehouseService.create(data).then((res) => {
          navigate("/warehouse");
          setLoading(false);
        });
      } else {
        // warehouseService.update(ID, data).then(res => {
        //     navigate("/warehouse")
        //     setLoading(false)
        // })
      }
    }
  };

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg min-h-[calc(100vh-48px)] bg-white">
      <h1 className="font-bold text-center text-3xl text-secondary mt-10">
        Add Warehouse
      </h1>
      <div className="mt-10 px-80">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8">
          <div>
            <label className="primary-label">Name</label>
            <input
              value={data.name}
              name="name"
              placeholder="Warehouse Name"
              onChange={(e) => handleChange(e)}
              className={`primary-input ${errors["name"] ? "!border-red-600" : ""}`}
            />
          </div>
          <div>
            <label className="primary-label">Address</label>
            <input
              value={data.location}
              name="location"
              placeholder="Warehouse Address"
              onChange={(e) => handleChange(e)}
              className={`primary-input ${errors["location"] ? "!border-red-600" : ""}`}
            />
          </div>
          <div>
            <label className="primary-label">Area</label>
            <input
              value={data.area}
              name="area"
              placeholder="Warehouse Area"
              onChange={(e) => handleChange(e)}
              className={`primary-input ${errors["location"] ? "!border-red-600" : ""}`}
            />
          </div>
        </div>
        <div className="flex justify-center mt-10">
          <SecondaryButton
            text="Add Warehouse"
            Icon={MdOutlineAdd}
            onClick={() => submit()}
          />
        </div>
      </div>
    </main>
  );
};

export default AddWarehouse;
